import { Component, isStandalone, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-modal-overlay',
  templateUrl: './modal-overlay.component.html',
  standalone: true
})
export class ModalOverlayComponent {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
